import React from 'react';
import { get } from 'lodash';
import axios from 'axios';
import { Stepper, Step, PopupChat } from '../components';
import EndProject from './EndProject';
import {
  FinanceDataForm,
  Payment,
  EnrollmentSummaryForm,
  FinanceDataProuniFies,
  EndStep,
} from '../forms';
import HealthRecord from '../forms/HealthRecord';
import PersonalDataStep from '../components/PersonalDataStep';
import NoticeStep from '../components/NoticeStep';
import { API_URL } from '../../lib/const';
import ComponentWithToken from '../components/CompontentWithToken';
import DocumentsStep from '../forms/DocumentsStep';
import Term from './Term';
import EspecialidadeStepPage from '../enrollment/pages/EspecialidadeStepPage';
import DismissalTermStepPage from '../enrollment/pages/DismissalTermStepPage';
import withPermission from '../../hoc/withPermission';

class Enroll extends ComponentWithToken {
  state = {
    steps: {},
    loading: true,
    loadingChat: true,
    loadingEnroll: true,
    current_step: 'NOTICE_STEP',
    steppers: [],
    closed_invite_process: false,
    gratuity: {},
    closedAt: null,
    kind: 'enroll',
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchFlow();
    this.fetchStatus();
    this.fetchSteps(true);
    this.fetchChat();
  }

  componentDidUpdate(prevProps) {
    const oldToken = prevProps.match.params.token;
    const newToken = this.props.match.params.token;

    if (oldToken !== newToken) {
      this.fetchFlow();
      this.fetchStatus();
      this.fetchSteps(true);
      this.fetchChat();
    }
  }

  get steps() {
    const { steppers } = this.state;
    return steppers.map((item) => ({
      ...item,
      description:
        item.id === 'CONTRACT_STEP' ? this.paymentText() : item.description,
    }));
  }

  getChild = (step, back, next, showProof, gratuity) => {
    const { kind } = this.state;

    switch (step) {
      case 'APPROVE_DISMISSAL_TERM':
        return (
          <DismissalTermStepPage
            backClick={() => this.jumpStep(back)}
            onClick={() => this.jumpStep(next)}
          />
        );

      case 'SPECIALTY_DATA_STEP':
        return (
          <EspecialidadeStepPage
            backClick={() => this.jumpStep(back)}
            onClick={() => this.jumpStep(next)}
          />
        );

      case 'PERSONAL_DATA_STEP':
        return (
          <PersonalDataStep
            backClick={() => this.jumpStep(back)}
            onClick={() => this.jumpStep(next)}
            subscriptionKind={kind === 'subscription'}
          />
        );

      case 'FINANCE_DATA_STEP':
        if (showProof) {
          return (
            <FinanceDataForm
              backClick={() => this.jumpStep(back)}
              onClick={() => this.jumpStep(next)}
            />
          );
        }
        return (
          <FinanceDataProuniFies
            gratuity={gratuity}
            backClick={() => this.jumpStep(back)}
            onClick={() => this.jumpStep(next)}
          />
        );

      case 'SUMMARY_STEP':
        return (
          <EnrollmentSummaryForm
            backClick={() => this.jumpStep(back)}
            onClick={next ? () => this.jumpStep(next) : undefined}
          />
        );

      case 'CONTRACT_STEP':
        return (
          <Payment token={this.token} backClick={() => this.jumpStep(back)} />
        );

      case 'FINALIZED_STEP':
        return (
          <EndStep token={this.token} backClick={() => this.jumpStep(back)} />
        );

      case 'DOCUMENT_STEP':
        return (
          <DocumentsStep
            backClick={() => this.jumpStep(back)}
            nextClick={() => this.jumpStep(next)}
          />
        );

      case 'HEALTH_STEP':
        return (
          <HealthRecord
            backClick={() => this.jumpStep(back)}
            onNext={() => this.jumpStep(next)}
          />
        );

      case 'TERM_STEP':
        return (
          <Term
            backClick={() => this.jumpStep(back)}
            onClick={() => this.jumpStep(next)}
          />
        );

      default:
        return <NoticeStep onClick={() => this.jumpStep(next)} />;
    }
  };

  fetchEndProcess() {
    const { history } = this.props;
    history.push('/encerramento');
  }

  paymentText() {
    const { status, showProof, ProofSent } = this.state;
    if (!showProof) {
      return 'Que bom que você concluiu a primeira etapa! Agora, você recebeu um e-mail com o link do contrato para assinatura eletrônica. Abaixo, está o boleto disponível para pagamento. Ambas as etapas devem ser concluídas para a efetivação da sua matrícula.';
    }
    if (status === 2) {
      return 'Que bom que você concluiu a primeira etapa! Agora você deve aguardar o retorno da análise que comunicada por email. Quando sua documentação for aprovada, será enviado um e-mail com o boleto e outro email com o link do contrato para que você assine eletronicamente.';
    }
    if (status === 3) {
      return 'Resolva as pendencias registradas pela faculdade.';
    }
    if (status === 5 || ProofSent) {
      return 'Que bom que você concluiu a primeira etapa! Agora, você recebeu um e-mail com o link do contrato para assinatura eletrônica. Abaixo, está o boleto disponível para pagamento. Ambas as etapas devem ser concluídas para a efetivação da sua matrícula.';
    }
    if (status === 6) {
      return 'Todas as etapas ja foram concluídas.';
    }
    return 'Que bom que você concluiu a primeira etapa! Agora, você recebeu um e-mail com o link do contrato para assinatura eletrônica. Abaixo, está o boleto disponível para pagamento. Ambas as etapas devem ser concluídas para a efetivação da sua matrícula.';
  }

  jumpStep(step) {
    this.fetchSteps();
    this.fetchStatus();
    this.setState({ current_step: step });
  }

  fetchStatus() {
    this.setState({ loadingEnroll: true });
    axios.get(`${API_URL}/onboarding/enroll/${this.token}`).then((response) => {
      localStorage.setItem('boleto_token', get(response, 'data.boleto_token'));
      console.log(response);
      this.setState({
        status: get(response, 'data.enrollment_status'),
        showProof: get(response, 'data.show_proof'),
        ProofSent: get(response, 'data.proof_sent'),
        gratuity: get(response, 'data.gratuity'),
        closed_invite_process: get(response, 'data.closed_invite_process'),
        closedAt: get(response, 'data.closed_at'),
        kind: get(response, 'data.kind'),
        loadingEnroll: false,
        eligible_for_subscription: get(
          response,
          'data.eligible_for_subscription'
        ),
        begin_date: get(response, 'data.inscription_start_date'),
        end_date: get(response, 'data.inscription_end_date'),
      });
    });
  }

  fetchChat() {
    axios.get(`${API_URL}/core/chat/${this.token}`).then((response) => {
      this.setState({
        currentUser: get(response, 'data.current_user', {}),
        supportUser: get(response, 'data.support_user', {}),
        signature: get(response, 'data.signature', {}),
        loadingChat: false,
      });
    });
  }

  fetchSteps(updateCurrentStep = false) {
    const { history } = this.props;
    this.setState({ loading: true });
    axios
      .get(`${API_URL}/onboarding/enrollments/${this.token}/steps`)
      .then((response) => {
        this.setState({
          loading: false,
          steps: response.data,
        });
        if (updateCurrentStep)
          this.setState({
            current_step: get(response.data, 'current_step', 'NOTICE_STEP'),
          });
      })
      .catch(() => {
        history.push('/login');
      });
  }

  fetchFlow = () => {
    const { history } = this.props;
    this.setState({ loading: true });
    axios
      .get(`${API_URL}/onboarding/flow-and-stages/${this.token}`)
      .then((response) => {
        const steppers = response.data.stages.map((item) => ({
          ...item,
          id: item.key,
        }));
        this.setState({ steppers });
      })
      .catch(() => {
        history.push('/login');
      });
  };

  renderStatus() {
    const { steps, current_step } = this.state;
    const default_steps = this.steps;
    const current_component_step = default_steps.filter(
      (step) => step.id === current_step
    )[0];
    if (get(current_component_step, 'step')) {
      return get(steps, current_component_step.step);
    }
    if (
      ['SUMMARY_STEP', 'CONTRACT_STEP'].some(
        (item) => get(current_component_step, 'id') === item
      )
    ) {
      return 'nonFieldStatus';
    }
    return null;
  }

  renderCurrentStep() {
    const { current_step, showProof, gratuity } = this.state;
    const default_steps = this.steps;
    if (current_step) {
      const current_component_step = default_steps.filter(
        (step) => step.id === current_step
      )[0];
      if (current_component_step) {
        return (
          <Step
            status={this.renderStatus()}
            label={current_component_step.label}
            description={current_component_step.description}
            ballLabel={current_component_step.position}
            active
          >
            {this.getChild(
              current_component_step.id,
              current_component_step.back_step,
              current_component_step.next_step,
              showProof,
              gratuity
            )}
          </Step>
        );
      }
    }

    return null;
  }

  render() {
    const {
      steppers,
      current_step,
      steps,
      loading,
      loadingChat,
      currentUser,
      supportUser,
      signature,
      loadingEnroll,
      closed_invite_process,
      closedAt,
      eligible_for_subscription,
      begin_date,
      end_date,
    } = this.state;

    return (
      <>
        {!loadingChat && (
          <PopupChat
            currentUser={currentUser}
            supportUser={supportUser}
            signature={signature}
          />
        )}
        {closed_invite_process ? (
          <EndProject
            closedAt={closedAt}
            eligibleForSubscription={eligible_for_subscription}
            beginDate={begin_date}
            endDate={end_date}
          />
        ) : (
          <div className="container">
            {steppers.length > 0 && (
              <Stepper
                steppers={steppers}
                active={current_step}
                status={steps}
              />
            )}
            {!(loading || loadingEnroll) && this.renderCurrentStep()}
          </div>
        )}
      </>
    );
  }
}

export default withPermission(Enroll);
